export const errorMessageMap = {
  LOAD_EXTERNAL_ID_MAPPING: 'Ошибка загрузки данных модели',
  LOAD_PROPERTY: 'Ошибка загрузки свойства модели',
  BAD_DATA: 'BAD_DATA',
  BAD_DATA_MODEL_IS_EMPTY: 'Пустая модель',
  BAD_DATA_NO_VIEWABLE_CONTENT: 'BAD_DATA_NO_VIEWABLE_CONTENT',
  BROWSER_WEBGL_DISABLED: 'В браузере отключена библиотека webGl',
  BROWSER_WEBGL_NOT_SUPPORTED: 'Библиотека webGl браузера не поддерживается',
  NETWORK_ACCESS_DENIED: 'Доступ к сети запрещен',
  NETWORK_FAILURE: 'Ошибка сети',
  NETWORK_FILE_NOT_FOUND: 'Файл не найден',
  NETWORK_SERVER_ERROR: 'Ошибка сервера',
  NETWORK_UNHANDLED_RESPONSE_CODE: 'Неверный код ответа',
  RTC_ERROR: 'RTC ошибка',
  UNKNOWN_FAILURE: 'Неизвестная ошибка',
  UNSUPORTED_FILE_EXTENSION: 'Расширение файла не поддерживается',
  VIEWER_INTERNAL_ERROR: 'Внутренняя ошибка вьювера',
  LOAD_AUTODESK_SCRIPT: 'Ошибка загрузки скрипта Autodesk'
};